import { FC } from 'react'

type LogoFooterProps = {
  width?: number
  height?: number
}

const LogoFooter: FC<LogoFooterProps> = ({ width = 77.2, height = 92 }) => {
  return (
    <svg
      id="logo-tate"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 77.202 92"
    >
      <g>
        <g transform="translate(2.413)">
          <path
            d="M237.056,217.674l-6.731-9.833a.593.593,0,0,1,0-.67l6.731-9.833a.593.593,0,0,1,.979,0l6.731,9.833a.593.593,0,0,1,0,.67l-6.731,9.833A.593.593,0,0,1,237.056,217.674Z"
            transform="translate(-201.358 -197.08)"
            fill="#00a26a"
          />
          <path
            d="M204.953,250.756l-9.833,6.731a.6.6,0,0,1-.67,0l-9.833-6.731a.593.593,0,0,1,0-.979l9.833-6.731a.6.6,0,0,1,.67,0l9.833,6.731A.594.594,0,0,1,204.953,250.756Z"
            transform="translate(-184.359 -214.079)"
            fill="#00a26a"
          />
          <path
            d="M215.392,228.709l-10.029-3.482a1.057,1.057,0,0,1-.651-.651l-3.481-10.029c-.174-.5.094-.77.6-.6l10.029,3.481a1.056,1.056,0,0,1,.651.652l3.482,10.029C216.162,228.616,215.895,228.884,215.392,228.709Z"
            transform="translate(-190.593 -203.314)"
            fill="#007b69"
          />
          <path
            d="M266.484,250.756l9.833,6.731a.6.6,0,0,0,.67,0l9.833-6.731a.594.594,0,0,0,0-.979l-9.833-6.731a.6.6,0,0,0-.67,0l-9.833,6.731A.593.593,0,0,0,266.484,250.756Z"
            transform="translate(-214.703 -214.079)"
            fill="#00a26a"
          />
          <path
            d="M259.571,228.709l10.029-3.482a1.055,1.055,0,0,0,.651-.651l3.482-10.029c.174-.5-.094-.77-.6-.6l-10.029,3.481a1.057,1.057,0,0,0-.652.652l-3.481,10.029C258.8,228.616,259.069,228.884,259.571,228.709Z"
            transform="translate(-211.996 -203.314)"
            fill="#007b69"
          />
          <path
            d="M237.056,279.2l-6.731,9.833a.593.593,0,0,0,0,.67l6.731,9.833a.593.593,0,0,0,.979,0l6.731-9.833a.593.593,0,0,0,0-.67l-6.731-9.833A.593.593,0,0,0,237.056,279.2Z"
            transform="translate(-201.358 -227.424)"
            fill="#00a26a"
          />
          <path
            d="M215.392,271.7l-10.029,3.482a1.057,1.057,0,0,0-.651.651l-3.481,10.029c-.174.5.094.77.6.6l10.029-3.481a1.056,1.056,0,0,0,.651-.652l3.482-10.029C216.162,271.79,215.895,271.522,215.392,271.7Z"
            transform="translate(-190.593 -224.717)"
            fill="#007b69"
          />
          <path
            d="M259.571,271.7l10.029,3.482a1.056,1.056,0,0,1,.651.651l3.482,10.029c.174.5-.094.77-.6.6l-10.029-3.481a1.057,1.057,0,0,1-.652-.652l-3.481-10.029C258.8,271.79,259.069,271.522,259.571,271.7Z"
            transform="translate(-211.996 -224.717)"
            fill="#007b69"
          />
        </g>
        <g transform="translate(0 84.557)">
          <path
            d="M184.355,331.5l3.252,7.3a.049.049,0,0,1-.045.07h-1.486a.05.05,0,0,1-.045-.03l-.568-1.275a.05.05,0,0,0-.046-.03H182.7a.049.049,0,0,0-.045.03l-.558,1.274a.05.05,0,0,1-.046.03h-1.476a.05.05,0,0,1-.045-.07l3.211-7.3Zm.5,4.518-.752-1.811a.05.05,0,0,0-.092,0l-.751,1.811a.05.05,0,0,0,.046.069h1.5A.05.05,0,0,0,184.85,336.018Z"
            transform="translate(-180.524 -331.46)"
          />
          <path
            d="M230.387,331.5l3.252,7.3a.05.05,0,0,1-.045.07h-1.486a.05.05,0,0,1-.045-.03l-.568-1.275a.049.049,0,0,0-.045-.03h-2.718a.049.049,0,0,0-.045.03l-.558,1.274a.05.05,0,0,1-.046.03h-1.476a.05.05,0,0,1-.045-.07l3.211-7.3Zm.5,4.518-.752-1.811a.05.05,0,0,0-.092,0l-.751,1.811a.05.05,0,0,0,.046.069h1.5A.05.05,0,0,0,230.883,336.018Z"
            transform="translate(-197.586 -331.46)"
          />
          <path
            d="M278.532,331.5l3.249,7.294a.053.053,0,0,1-.048.076h-1.478l-.049-.032-.566-1.273a.05.05,0,0,0-.046-.03h-2.718a.049.049,0,0,0-.045.03l-.557,1.273-.049.032h-1.467a.054.054,0,0,1-.049-.076l3.208-7.294Zm.5,4.518-.752-1.811a.05.05,0,0,0-.092,0l-.751,1.811a.05.05,0,0,0,.046.069h1.5A.05.05,0,0,0,279.027,336.018Z"
            transform="translate(-215.432 -331.46)"
          />
          <path
            d="M202.378,338.87h-4.289a.05.05,0,0,1-.05-.05v-7.27a.05.05,0,0,1,.05-.05h1.349a.049.049,0,0,1,.05.05v5.822a.05.05,0,0,0,.05.05h2.84a.049.049,0,0,1,.05.05v1.349A.05.05,0,0,1,202.378,338.87Z"
            transform="translate(-187.016 -331.46)"
          />
          <path
            d="M212.043,338.82v-7.27a.049.049,0,0,1,.05-.05h2.483a3.8,3.8,0,0,1,1.465.269,3.131,3.131,0,0,1,1.11.758,3.408,3.408,0,0,1,.709,1.169,4.311,4.311,0,0,1,.25,1.5,4.1,4.1,0,0,1-.25,1.447,3.486,3.486,0,0,1-.709,1.163,3.277,3.277,0,0,1-1.11.779,3.628,3.628,0,0,1-1.465.284h-2.483A.05.05,0,0,1,212.043,338.82Zm1.439-1.463a.05.05,0,0,0,.05.05h1.045a2.011,2.011,0,0,0,1.49-.637,2.159,2.159,0,0,0,.438-.705,2.485,2.485,0,0,0,0-1.737,2.159,2.159,0,0,0-.438-.706,2.084,2.084,0,0,0-.662-.474,1.971,1.971,0,0,0-.828-.174h-1.045a.05.05,0,0,0-.05.05Z"
            transform="translate(-192.207 -331.46)"
          />
          <path
            d="M246.063,334.678h2.756a.049.049,0,0,1,.05.05v3.033a.054.054,0,0,1-.018.04,4.671,4.671,0,0,1-1.217.8,3.487,3.487,0,0,1-1.413.281,3.607,3.607,0,0,1-1.532-.318,3.743,3.743,0,0,1-1.173-.835,3.655,3.655,0,0,1-.745-1.183,3.75,3.75,0,0,1-.261-1.376,3.641,3.641,0,0,1,.318-1.537,3.676,3.676,0,0,1,2.017-1.929,3.691,3.691,0,0,1,1.375-.266,3.6,3.6,0,0,1,1.439.3,4.078,4.078,0,0,1,1.235.84.052.052,0,0,1,0,.072l-.956,1.006h0a3.064,3.064,0,0,0-.828-.568,2.127,2.127,0,0,0-.892-.2,2.2,2.2,0,0,0-.88.177,2.23,2.23,0,0,0-.719.49,2.312,2.312,0,0,0-.485.729,2.237,2.237,0,0,0-.177.886,2.2,2.2,0,0,0,.177.88,2.268,2.268,0,0,0,1.2,1.2,2.2,2.2,0,0,0,.88.177,2.276,2.276,0,0,0,.626-.089,2.545,2.545,0,0,0,.584-.245v-.969h-1.368a.049.049,0,0,1-.05-.05v-1.349A.049.049,0,0,1,246.063,334.678Z"
            transform="translate(-203.5 -331.436)"
          />
          <path
            d="M266.089,338.87h-1.651a.05.05,0,0,1-.04-.021l-1.95-2.769a.051.051,0,0,0-.041-.021h-.85v2.762a.05.05,0,0,1-.05.05h-1.485a.05.05,0,0,1-.05-.05v-7.27a.049.049,0,0,1,.05-.05h3.046a2.128,2.128,0,0,1,.865.179,2.311,2.311,0,0,1,.714.49,2.394,2.394,0,0,1,.49.721,2.157,2.157,0,0,1,.183.884,2.256,2.256,0,0,1-.355,1.247,2.147,2.147,0,0,1-.876.792.047.047,0,0,0-.019.07l2.059,2.908A.05.05,0,0,1,266.089,338.87Zm-3.291-4.264a1.146,1.146,0,0,0,.813-.247.778.778,0,0,0,.261-.585.746.746,0,0,0-.261-.574,1.179,1.179,0,0,0-.812-.237h-1.191a.049.049,0,0,0-.05.05v1.543a.05.05,0,0,0,.05.05Z"
            transform="translate(-209.971 -331.46)"
          />
          <path
            d="M294.965,337.194l-1.791-2.483a.05.05,0,0,0-.09.029v4.046a.084.084,0,0,1-.084.084h-1.316a.05.05,0,0,1-.05-.05V331.5h.961a.05.05,0,0,1,.041.021l2.595,3.593a.049.049,0,0,0,.081,0l2.6-3.593a.05.05,0,0,1,.04-.021h.923a.056.056,0,0,1,.038.053v7.233a.084.084,0,0,1-.083.084h-1.283a.084.084,0,0,1-.083-.084V334.74a.05.05,0,0,0-.09-.029l-1.79,2.483Z"
            transform="translate(-221.707 -331.46)"
          />
        </g>
      </g>
    </svg>
  )
}

export default LogoFooter
